import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\USUARIO\\Escritorio\\¨MERCALIA¨\\SITIO WEB\\mercaliaconnect\\src\\app\\terms\\components\\TermsContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\USUARIO\\Escritorio\\¨MERCALIA¨\\SITIO WEB\\mercaliaconnect\\src\\components\\FooterClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\USUARIO\\Escritorio\\¨MERCALIA¨\\SITIO WEB\\mercaliaconnect\\src\\components\\Header.tsx");
